import React from 'react'
import "./components.css"
import UserImage from "../assets/user.png"
import { Link } from 'react-router-dom'

const UserCard = ({ user }) => {
    return (
        <Link to={`/user/${user._id}`}>
            <div className="user-card-container">
                <div className="user-card-profile-image">
                    <img src={user?.profilePic?.url ? user.profilePic.url : UserImage} alt='' />
                </div>
                <div className="user-profile-name">
                    <h3 className="">{user?.firstname} {user?.lastname}</h3>
                </div>
            </div>
        </Link>
    )
}

export default UserCard